import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestResults from './components/LatestResults';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '六合彩指南',
    url: 'https://liuhecai-zhinan.example.com',
    description: '汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://liuhecai-zhinan.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '六合彩网站精选推荐与玩法指南',
    description: '本页汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。',
    url: 'https://liuhecai-zhinan.example.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '六合彩指南',
      url: 'https://liuhecai-zhinan.example.com',
    },
  };

  return (
    <>
      <SEOHead
        title="六合彩网站精选推荐与玩法指南 | 六合彩指南"
        description="本页汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。无论您是新手还是老玩家，都能在此找到可靠的六合彩网站使用指南，助您安全、理性参与娱乐。"
        keywords="六合彩网站,六合彩网站推荐,六合彩开奖结果查询,六合彩玩法规则,六合彩选号技巧,正规六合彩平台,六合彩网站评测"
        canonicalUrl="https://liuhecai-zhinan.example.com"
        schema={{ ...websiteSchema, ...webpageSchema }}
      />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <LatestResults />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}